import { render, staticRenderFns } from "./VesselSelectSimple.vue?vue&type=template&id=3f0e2aac&scoped=true&"
import script from "./VesselSelectSimple.vue?vue&type=script&lang=ts&"
export * from "./VesselSelectSimple.vue?vue&type=script&lang=ts&"
import style0 from "./VesselSelectSimple.vue?vue&type=style&index=0&id=3f0e2aac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0e2aac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VCheckbox,VList,VListItem})
